module.exports = "<manual-invoice-items-page></manual-invoice-items-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/manualInvoiceItemsView.html
// module id = 2163
// module chunks = 0